<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="mb-4 card-small">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="6">
              <h6 class="m-0">
                {{ $t('huntingWordsGenerator.card.title') }}
              </h6>
            </d-col>
          </d-row>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <hunting-words-form
                  ref="hunting_word_form"
                  v-if="huntingWords"
                />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <!-- Sidebar Widgets -->
      <sidebar-actions :model.sync="huntingWords" @save="save" />
    </d-col>
    <ScrollToTop />
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import events from '_utils/events';
import ScrollToTop from '_shared/ScrollToTop.vue';
import HuntingWordsForm from './HuntingWordsForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_MODEL_, MODEL } from './HuntingWordsModel';

export default {
  name: 'hunting-words-page',
  components: {
    HuntingWordsForm,
    SidebarActions,
    ScrollToTop,
  },
  computed: {
    huntingWords() {
      const { huntingWords } = this.$store.state.huntingWordsGenerator;
      if (huntingWords) {
        return huntingWords;
      }
      return cloneDeep(MODEL);
    },
  },
  watch: {
    huntingWords(newValue) {
      if (newValue) {
        events.$emit(_LOAD_MODEL_, newValue);
      }
    },
  },
  methods: {
    save() {
      this.$refs.hunting_word_form.save();
    },
  },
};
</script>
